import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const FilterLabelContainer = styled('div')<{
    theme?: TTheme
    onClick?: () => void
}>`
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.semantic.filterLabelBackground};
    border: 1px solid ${({ theme }) => theme.colors.primary[300]};
    color: ${({ theme }) => theme.colors.primary[300]};
    border-radius: 999px;
    padding: 6px 18px;
    height: 29px;
    box-sizing: border-box;
    gap: 8px;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`

export const CloseButton = styled('button')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin-left: 8px;
    cursor: pointer;
    outline: none;

    svg {
        width: 8px;
        height: 8px;
        color: ${({ theme }) => theme.colors.primary[300]};
        transition: color 0.2s;
    }

    &:hover svg {
        color: ${({ theme }) => theme.colors.primary[600]};
    }
`
